import './index.less';

import { useEffect } from 'react';

import { useFingerPrint } from '@/hooks/useFingerPrint';
import { useUserProfile } from '@/hooks/useUserProfile';

import { CreateApiBreadCrumb } from './comps/CreateApiBreadCrumb';
import { CreateApiForm } from './comps/CreateApiForm';

const CreateApiPage = () => {
  const { profile } = useUserProfile();

  const { fingerReport } = useFingerPrint();

  useEffect(() => {
    if (profile?.result?.id) {
      fingerReport('wf07', '0');
    }
  }, [profile]);

  return (
    <div className="by-us-fe-main create-new-api-key">
      <CreateApiBreadCrumb />
      <CreateApiForm />
    </div>
  );
};

export default CreateApiPage;
